import {ActionService, ConfigurationService, JwtHttpClientService, ResourceModule} from "@fedeltapointofsale/data-client";
import {Inject, Injectable} from "@angular/core";

export class LocationRequestTyroDeviceCodeActionResult {
    constructor(public device_code: string, public user_code: string, public verification_uri: string,
                public expires_in: number, public interval: number, public verification_uri_complete: string) {
    }
}

@Injectable()
export class LocationRequestTyroDeviceCodeService extends ActionService {
    constructor(http: JwtHttpClientService,
                configService: ConfigurationService,
                @Inject(ResourceModule.RESOURCE_NAMESPACE_KEY) nameSpace,
                @Inject(ResourceModule.ACTION_NAMES_KEY) actionNames) {
        super(http, configService, nameSpace, actionNames, "location-request-tyro-device-code");
    }
}
